"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("@chakra-ui/react");

var _FaSearchMinus = require("@react-icons/all-files/fa/FaSearchMinus");

var _FaSearchPlus = require("@react-icons/all-files/fa/FaSearchPlus");

var _react2 = require("react");

var _reactZoomPanPinch = require("react-zoom-pan-pinch");

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["zoomIn", "zoomOut", "resetTransform"];

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var ImageViewer = function ImageViewer(props) {
  var bg = (0, _react.useColorModeValue)('white', 'gray.600');
  var borderColor = (0, _react.useColorModeValue)('gray.100', '#FFFFFF14');

  var _useState = (0, _react2.useState)(1),
      _useState2 = _slicedToArray(_useState, 2),
      scale = _useState2[0],
      setScale = _useState2[1];

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Portal, {
    appendToParentPortal: false,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Box, {
      pos: "fixed",
      top: 0,
      zIndex: "popover",
      w: "100%",
      h: "100vh",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactZoomPanPinch.TransformWrapper, {
        initialScale: scale,
        doubleClick: {
          disabled: true
        },
        onZoom: function onZoom(ref) {
          setScale(ref.state.scale);
        },
        minScale: 0.5,
        maxScale: 8,
        children: function children(_ref) {
          var zoomIn = _ref.zoomIn,
              zoomOut = _ref.zoomOut,
              resetTransform = _ref.resetTransform,
              rest = _objectWithoutProperties(_ref, _excluded);

          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Flex, {
              zIndex: 999,
              direction: "column",
              overflow: "hidden",
              left: 0,
              top: 0,
              h: "100%",
              w: "100%",
              pos: "absolute",
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_react.HStack, {
                borderBottom: "solid 1px",
                bg: bg,
                borderColor: borderColor,
                pb: 3,
                pt: 3,
                pr: 2,
                h: '7.5vh',
                children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Flex, {
                  width: "100%",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Spacer, {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.HStack, {
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Button, {
                      onClick: props.onOpenStudio,
                      children: "Snek Studio"
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Divider, {
                      orientation: "vertical"
                    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Text, {
                      fontSize: "xs",
                      minW: 35,
                      textAlign: "center",
                      userSelect: "none",
                      children: [Math.round(scale * 100), "%"]
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.IconButton, {
                      "aria-label": "a",
                      icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FaSearchPlus.FaSearchPlus, {}),
                      opacity: scale === 8 ? 0.5 : 1 // onClick={() => onSetScale(1)}
                      ,
                      onClick: function onClick() {
                        zoomIn();

                        if (scale + 0.2 > 8) {
                          setScale(8);
                        } else {
                          setScale(scale + 0.2);
                        }
                      }
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.IconButton, {
                      "aria-label": "a",
                      icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FaSearchMinus.FaSearchMinus, {}),
                      opacity: scale === 0.5 ? 0.5 : 1 // onClick={() => onSetScale(0)}
                      ,
                      onClick: function onClick() {
                        zoomOut();

                        if (scale - 0.2 < 0.5) {
                          setScale(0.5);
                        } else {
                          setScale(scale - 0.2);
                        }
                      }
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.CloseButton, {
                      onClick: props.onClose
                    })]
                  })]
                })
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Center, {
                bg: "rgba(0,0,0,0.6)",
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactZoomPanPinch.TransformComponent, {
                  contentStyle: {
                    height: '100vh'
                  },
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Image, {
                    src: props.src,
                    h: "100%"
                  })
                })
              })]
            })
          });
        }
      })
    })
  });
};

var _default = ImageViewer;
exports["default"] = _default;